import React, { useRef } from 'react';
import { registry } from '../../core/Registry.js';
import { BaseWidget } from '../BaseWidget.jsx';

export function SliderRender({ node, isLiveMode, children }) {
  const content = node.content || {};
  
  const gap = content.gap || '20px';
  const itemWidth = content.itemWidth || '80%';
  const snap = content.snap === 'true';

  const scrollContainerRef = useRef(null);

  const scrollLeft = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({ left: -300, behavior: 'smooth' });
    }
  };

  const scrollRight = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({ left: 300, behavior: 'smooth' });
    }
  };

  return (
    <div style={{ width: '100%', position: 'relative' }}>
      
      {/* Navigation Layer */}
      {isLiveMode && (
        <>
          <button 
            onClick={scrollLeft}
            style={{
              position: 'absolute', left: '-20px', top: '50%', transform: 'translateY(-50%)', zIndex: 10,
              background: 'rgba(0,0,0,0.5)', color: '#fff', border: 'none', borderRadius: '50%', width: '40px', height: '40px', cursor: 'pointer'
            }}
          >←</button>
          <button 
            onClick={scrollRight}
            style={{
              position: 'absolute', right: '-20px', top: '50%', transform: 'translateY(-50%)', zIndex: 10,
              background: 'rgba(0,0,0,0.5)', color: '#fff', border: 'none', borderRadius: '50%', width: '40px', height: '40px', cursor: 'pointer'
            }}
          >→</button>
        </>
      )}

      {/* Scroll Container (Native CSS Scroll Snap) */}
      <div 
        ref={scrollContainerRef}
        className="tef-slider-container"
        style={{
          display: 'flex',
          gap: gap,
          overflowX: 'auto',
          scrollSnapType: snap ? 'x mandatory' : 'none',
          scrollbarWidth: 'none', // Firefox
          msOverflowStyle: 'none', // IE
          padding: '10px 0',
          minHeight: '100px',
          background: !children || children.length === 0 ? 'rgba(255,255,255,0.02)' : 'transparent',
          border: !children || children.length === 0 ? '1px dashed rgba(255,255,255,0.2)' : 'none'
        }}
      >
        {(!children || children.length === 0) ? (
          <div style={{ padding: '20px', color: '#64748b' }}>Slider: Ziehe Widgets hier hinein! Jedes Kind wird zu einem Slide.</div>
        ) : (
          React.Children.map(children, (child) => (
            <div style={{
              flex: `0 0 ${itemWidth}`,
              scrollSnapAlign: snap ? 'center' : 'none',
              maxWidth: itemWidth
            }}>
              {child}
            </div>
          ))
        )}
      </div>
    </div>
  );
}

registry.register('Slider', {
  label: 'Slider / Carousel',
  icon: '↔️', 
  category: 'layout', // Eher Layout, da es Container für Slides ist
  component: SliderRender,
  
  defaultProps: {
    children: [], // Erlaubt Nested Elements (Jedes Element wird zu einem Slide)
    content: {
      gap: '20px',
      itemWidth: '80%',
      snap: 'true'
    },
    style: {
      desktop: {
        marginBottom: '20px',
        padding: '10px'
      }
    }
  },

  inspectorControls: [
    {
      tab: 'content',
      groups: [
        {
          title: 'Slider Settings',
          fields: [
            { name: 'content.itemWidth', label: 'Breite pro Slide (z.B. 80%, 300px)', type: 'text' },
            { name: 'content.gap', label: 'Abstand zwischen Slides', type: 'text' },
            { name: 'content.snap', label: 'CSS Scroll-Snap aktivieren?', type: 'select', options: ['true', 'false'] }
          ]
        }
      ]
    }
  ]
});
